import styled, { css } from 'styled-components/macro'
import palmReverseBackgroundDecor from 'assets/images/decors/palmReverseBackgroundDecor.svg'
import palmBackgroundDecor from 'assets/images/decors/palmBackgroundDecor.svg'
import barBackgroundDecor from 'assets/images/decors/barBackgroundDecor.svg'
import baloonsDecor from 'assets/images/decors/baloonsDecor.svg'
import cakeDecor from 'assets/images/decors/cakeDecor.svg'
import notFoundBackground from 'assets/images/notFound/notFoundBackground.svg'
import { respondAbove } from 'styles/mediaQueries'

interface ContentProps {
    backgroundDecor?: 'palm' | 'park' | 'palmReversed' | 'birthday'
}

export const Content = styled.div<ContentProps>`
    height: fit-content;
    background-color: ${({ theme }) => theme.colors.grayscale_200};
    min-height: calc(100vh - 60px);

    @media ${respondAbove.md} {
        min-height: calc(100vh - 84px);
    }

    ${({ backgroundDecor }) => {
        if (backgroundDecor === 'palm') {
            return css`
                @media ${respondAbove.xl} {
                    background-image: url(${palmBackgroundDecor}),
                        url(${barBackgroundDecor});
                    background-repeat: no-repeat;
                    background-position: 95% 340px, 95% 1468px;
                }
            `
        } else if (backgroundDecor === 'park') {
            return css`
                background-image: url(${notFoundBackground});
                background-position: left bottom;
                background-repeat: no-repeat;
                background-size: contain;

                @media ${respondAbove.xl} {
                    background-position: right bottom;
                    background-size: auto 600px;
                }
            `
        } else if (backgroundDecor === 'palmReversed') {
            return css`
                @media ${respondAbove.xl} {
                    height: 86vh;
                    background-image: url(${palmReverseBackgroundDecor});
                    background-repeat: no-repeat;
                    background-position: left 0px bottom;
                }
            `
        } else if (backgroundDecor === 'birthday') {
            return css`
                @media ${respondAbove.xl} {
                    background-image: url(${cakeDecor}), url(${baloonsDecor});
                    background-repeat: no-repeat;
                    background-position: 95% 340px, 95% 1468px;
                }
            `
        }
    }}
`

export const PageWrapper = styled.div`
    min-height: 100vh;
`
